import { useWatch } from "react-hook-form";



export default function TotalHours({control,}) {

  const serviceLogTimeActivitiesList = useWatch({ control, name: `activities` });

  const sum = serviceLogTimeActivitiesList?.map(elem => +elem?.hours)?.reduce((a, b) => a + b);



  return (
    !isNaN(sum) && serviceLogTimeActivitiesList?.length > 1 && (
        <div className="sm:px-7 px-4 mt-2">
          {' '}
          <p className="text-lg font-semibold">TOTAL {sum}</p>{' '}
        </div>
      )
  );
}
